/* tslint:disable:max-line-length */
export default {
	loss_cert: {
		en: "Request for the issuance of a replacement of damaged or lost title deed.",
		ar: "طلب إصدار بدل فاقد أو تالف.",
	},
	electronic_title_deed: {
		en: "Download the title deed copy of the property.",
		ar: "تنزيل نسخة من سند الملكية.",
	},
	prop_valuation: {
		en: "Request for the issuance of a property valuation certificate from the Dubai Land Department.",
		ar: "طلب إصدار شهادة تثمين عقاري من دائرة الأراضي والأملاك بدبي.",
	},
	iprop_valuation: {
		en: "Procedure to evaluate the property for grant purpose",
		ar: "يمكنك الان تحميل مخطط الموقع للعقار",
	},
	site_plan: {
		en: "Request for the issuance of a map as per the approved plans from the Survey Section at Land Department.",
		ar: "طلب إصدار خارطة حسب الخرائط المعتمدة من قسم المساحة بإدارة الأراضي.",
	},
	ejari: {
		en: "View details and manage Ejari contracts. Register, renew/terminate Ejari.",
		ar: "عرض تفاصيل وادارة عقود الإيجار. تسجيل وتجديد / إنهاء إيجاري.",
	},
	regi_case: {
		en: "Register rental cases and reconciliation cases and submit to Rental Dispute Center.",
		ar: "تقديم الدعاوي الإيجارية ودعاوي الصلح إلى مركز المنازعات الإيجارية.",
	},
	mortgage_quotation: {
		en: "Send your Mortgage request to Bank and receive quotations from Bank. ",
		ar: "إرسال طلب الرهن العقاري الخاص بك إلى البنك وتلقي عروض الأسعار من البنك.",
	},
	third_party_valuation: {
		en: "Request for external valuation from an approved valuation company.",
		ar: "طلب تقييم خارجي من شركة التقييم معتمدة.",
	},
	mollak_service_charges: {
		en: "View service charge details, download invoices, and pay online. ",
		ar: "عرض تفاصيل رسوم الخدمات وتنزيل الفواتير والدفع عبر الإنترنت.",
	},
	myrequest: {
		en: "View your past requests, check the status and option for new request.",
		ar: "عرض طلباتك السابقة ، و تحقق من الحالة و الخيار للطلب الجديد",
	},
	raise_a_complaint: {
		en: "This service allow registration of complaints related to violations of real estate companies.",
		ar: "تتيح هذه الخدمة تقديم الشكاوي المتعلقة بالمخالفات المرتكبة من قبل الشركات العقارية.",
	},
	sell_prop: {
		en: "Initiate selling of your property to a buyer.",
		ar: "البدء بإجراء ببيع العقار للمشتري",
	},
	listings_rent: {
		en: "List this property for rent on Dubai REST and Simsari.",
		ar: "عرض العقار للإيجار في دبي ريست وسمساري",
	},
	listings_sell: {
		en: "List this property for sell on Dubai REST and Simsari.",
		ar: "عرض العقار للبيع في دبي ريست وسمساري",
	},
	rt_registration: {
		en: "Submit a procedure request to Registration Trustee office.",
		ar: "ارسل طلب من خلال مكاتب امناء التسجيل.",
	},
	tasken: {
		en: "Granting an investor visa from this property.",
		ar: "منح تأشيرة مستثمر من هذا العقار.",
	},
	rental_valuation: {
		en: "This service allows customers to request for property rent valuation.",
		ar: "تتيح هذه الخدمة للعملاء تقديم طلب تقييم قيمة الإيجار للعقار.",
	},
	owner_committee: {
		en: "This service allows the owner to apply for committee member.",
		ar: "تتيح هذه الخدمة للمالك بتقديم طلب العضوية في لجنة الملاك.",
	},
	create_new_contract: {
		en: "You can create a new Ejari contract by entering the tenant information and contract details.",
		ar: "يمكنك انشاء عقد إيجاري عن طريق إدخال بيانات المستأجر و بيانات العقد"
	},
	renew_contract: {
		en: "You can renew your Ejari contract by reviewing the current contract and taking the required action",
		ar: "يمكنك تجديد عقد إيجاري عن طريق مراجعة العقد الحالي متخذا الإجراءات المطلوبة"
	},
	terminate_contract: {
		en: "You can terminate the Ejari contract by reviewing the current contract and taking the required action",
		ar: "يمكنك إنهاء عقد إيجاري عن طريق مراجعة العقد الحالي متخذا الإجراءات المطلوبة"
	},
	edit_ejari: {
		en: "You can edit the services related to the specific property and update the information",
		ar: "يمكنك تعديل الخدمات المتعلقه بالعقار و تحديث المعلومات"
	},
	external_valuation: {
		en: "Request for external valuation from an approved valuation company.",
		ar: "طلب تقييم خارجي من شركة تقييم معتمدة.",
	},
	sale_contract: {
		en: "This represents an agreement that is signed between seller and buyer. Now you can download the sale contract",
		ar: "هذا العقد يمثل الإتفاقية الموقعة بين كل من البائع و المشتري. يمكنك الآن تنزيل عقد البيع",
	},
	rdc_cases: {
		en: "This service allows the owner to see the RDC cases registered on the property.",
		ar: "تتيح هذة الخدمة الإطلاع على القضايا المسجلة على العقارات المسجلة للملاك",
	},
	enoc_mollak: {
		en: "Request for electronic no objection certificate from owner association property management company for transfer of property",
		ar: "طلب شهادة عدم ممانعة إلكترونية من شركة إدارة الأملاك التابعة لاتحاد الملاك لنقل ملكية",
	},
	ptwimc: {
		en: "Requests for whomsoever it may concern for a property certificate. Go to My Request to view past requests.",
		ar: "تتيح هذه الخدمة للمتعاملين القيام بتسجيل طلب إصدار شهادة بيان تفصيلية لعقار أو شهادة استيفاء بالمتطلبات الخاصة بإدارة العقارات.",
	},
	add_your_property: {
		en: "This service allows Owners to add any missing NFH properties (Building & Unit / Villas) and allows them to create tenancy contract on that property",
		ar: "تتيح هذه الخدمة للمالكين إضافة أي عقارات للتملك الغير حر المفقودة (مبنى ووحدة / فلل) وتسمح لهم بإنشاء عقد إيجار على ذلك العقار",
	},
	bcs_reclassification: {
		en: "This service allows customers to obtain a project report, know the condition of the land, and classify buildings according to the stars system.",
		ar: "تتيح هذه الخدمة للمتعاملين بالحصول على تقرير مشروع ومعرفة حالة الأرض وتصنيف المباني بنظام النجوم.",
	},
	handover_request: {
		en: "This service allows the landlord to request a sign-off from the tenant witnessing the condition of the property at the time of handover from landlord.",
		ar: "تتيح هذه الخدمة للمالك طلب موافقة المستأجر على حالة العقار وقت التسليم من المالك.",
	},
	takeover_request: {
		en: "This service allows the landlord to request a sign-off from the tenant witnessing the condition of the property at the time of handing off to landlord.",
		ar: "تتيح هذه الخدمة للمالك طلب موافقة المستأجر على حالة العقار وقت التسليم للمالك.",
	},
	ppty_cooccupant: {
		en: "This service to request view/add/delete co-occupants from ejari contract on this property.",
		ar: "هذه الخدمة لطلب عرض / إضافة / حذف بيانات القاطنين من عقد إيجاري على هذا العقار.",
	},
	site_plan_download: {
		en: "Now you can download the Site Map of your property.",
		ar: "يمكنك الان تحميل مخطط الموقع للعقار",
	},
	create_management_contract: {
		en: "This service allows the landlord to register new management contract with the real estate management company for one or more properties.",
		ar: "تتيح هذه الخدمة للمالك تسجيل عقد إدارة جديد مع شركة إدارة العقارات لعقار واحد أو أكثر.",
	},
	renew_management_contract: {
		en: "This service allows the landlord to renew an existing active management contract with the real estate management company.",
		ar: "تتيح هذه الخدمة للمالك تجديد عقد إدارة فعال قائم مع شركة إدارة العقارات.",
	},
	terminate_management_contract: {
		en: "This services allows the landlord to initiate a termination request to end the management contract.",
		ar: "تسمح هذه الخدمات للمالك ببدء طلب إنهاء لإنهاء عقد الإدارة.",
	},
	view_management_contract_requests: {
		en: "This services allows the landlord to view all the request and the details of the management contract.",
		ar: "تتيح هذه الخدمات للمالك الاطلاع على جميع الطلبات وتفاصيل عقد الإدارة.",
	},
	jop_services: {
		en: "A service that allows owners of the real estate units and tenants in the jointly owned properties to submit (suggestion, enquires or requests and complaints). It also allows owners committee to submit requests and issues rectification notice to hthe management company and following up on the owners submitted requests.",
		ar: " خدمة تتيح للملاك الوحدات العقارية والمستأجرين في العقارات المشتركة لتقديم  ( الاقتراحات ، الاستفسارات أو طلبات  والشكاوى ) كما تتيح للجنة الملاك  تقديم الطلبات وإصدار إنذارات تعديل الوضع لجهة الإدارة مع متابعة طلبات الملاك المقدمة."
	},
	jop_enquiry: {
		en: "A service that allow owners of the real estate to submit enquires and requests regarding jointly owned property",
		ar: "خدمة تتيح لملاك الوحدات العقارية تقديم الاستفسارات و طلبات الخاصة بالعقار المشترك"
	},
	jop_suggestion: {
		en: "A services that allows owners of the real estate unit to submit improvement / Idea in jointly owned property",
		ar: "خدمة تتيح لملاك الوحدات العقارية تحسين الخدمات في العقار المشترك"
	},
	jop_complaints: {
		en: "A service that allows owners of the real estate unit to submit complaints against ( Management Companies, Company Employees, Service providers, Owners committee) related to the jointly owned property",
		ar: "خدمة تتيح لملاك الوحدات العقارية تقديم الشكاوي ضد(شركات الإدارة أو موظفين الشركات، مزودي الخدمات، لجنة الملاك) المتعلقة بالعقار المشترك"
	},
	jop_legal: {
		en: "A service that allow owners committees to provide a written notice to rectify conditions related to the jointly owned property",
		ar: "خدمة تتيح لجان الملاك تقديم إنذار خطي بتصويب الأوضاع المتعلقة بالعقار المشترك"
	},
};
